"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _arrowDiagonalBlack = _interopRequireDefault(require("../../images/arrow-diagonal-black.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MegaNavSection = _ref => {
  let {
    content,
    featuredColumnRef,
    Link
  } = _ref;
  const [showScrollIcon, setShowScrollIcon] = (0, _react.useState)(featuredColumnRef?.current?.offsetHeight > 610 ? true : false);
  const displayChevrons = content?.displayChevrons; // don't display by default
  const disableLinkDescriptions = content?.disableLinkDescriptions; // display by default
  const [maxTitleHeight, setMaxTitleHeight] = (0, _react.useState)(0); // max height of column title

  const endOfOverflowScrollCheck = items => {
    let callback = (entries, observer) => {
      entries?.forEach(entry => {
        if (entry?.isIntersecting) {
          // if indicator element is visible in the DOM, we've reached the bottom of the scroll and the icon should be hidden.
          setShowScrollIcon(false);
        } else {
          setShowScrollIcon(true);
        }
      });
    };
    let observer = new IntersectionObserver(callback, {
      rootMargin: "0px",
      threshold: 1.0
    });
    items?.forEach(item => {
      observer?.observe(item);
    });
  };
  (0, _react.useEffect)(() => {
    if (document != "undefined") {
      endOfOverflowScrollCheck(document?.querySelectorAll('.ter-mega-nav__column-end-indicator'));
    }
  }, [featuredColumnRef?.current?.scrollTop]);
  const OverflowIndicator = _ref2 => {
    let {
      leftPos
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: `ter-mega-nav__overflow-indicator`,
      style: {
        left: `${leftPos?.current?.offsetLeft - 22}px`
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "11",
      fill: "currentColor",
      className: `ter-mega-nav__overflow-indicator-icon`,
      role: "img",
      "aria-label": "indicator chevron icon"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fill: "#fff",
      d: "M1.88.453 8 6.56 14.12.453 16 2.333l-8 8-8-8L1.88.453Z"
    })));
  };
  const ColumnTitle = _ref3 => {
    let {
      column,
      maxTitleHeight,
      setMaxTitleHeight,
      columnChecked
    } = _ref3;
    const columnTitleRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(() => {
      if (columnTitleRef?.current?.offsetHeight > maxTitleHeight && columnChecked === false) {
        setMaxTitleHeight(columnTitleRef?.current?.offsetHeight);
        columnChecked = true;
      }
    }, [columnTitleRef, maxTitleHeight]);
    const generateTitleClass = maxTitleHeight => {
      if (maxTitleHeight > 78) {
        return "ter-mega-nav__column-title--four-lines";
      } else if (maxTitleHeight >= 61) {
        return "ter-mega-nav__column-title--three-lines";
      } else if (maxTitleHeight >= 40) {
        return "ter-mega-nav__column-title--two-lines";
      } else if (maxTitleHeight < 40) {
        return "ter-mega-nav__column-title--one-line";
      }
    };
    return /*#__PURE__*/_react.default.createElement("span", {
      className: `ter-mega-nav__column-title ${generateTitleClass(maxTitleHeight)}`,
      ref: columnTitleRef
    }, column?.title);
  };
  const renderMegaNavColumn = (column, index) => {
    let columnChecked = false;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: `ter-mega-nav__column`
    }, /*#__PURE__*/_react.default.createElement(ColumnTitle, {
      column: column,
      maxTitleHeight: maxTitleHeight,
      setMaxTitleHeight: setMaxTitleHeight,
      columnChecked: columnChecked
    }), /*#__PURE__*/_react.default.createElement("ul", {
      className: `ter-mega-nav__column-list`
    }, column?.links?.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index,
        className: "ter-mega-nav__column-list-item"
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        key: index,
        to: link?.url,
        target: link?.external ? "_blank" : "_self",
        Link: Link,
        className: "ter-mega-nav__link"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: `ter-mega-nav__link-text ${displayChevrons ? ' ter-mega-nav__link-text--chevrons' : ''}`
      }, link?.icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: "ter-mega-nav__link-icon",
        size: "22px",
        type: link?.icon,
        sbProps: link?.contentfulId ? {
          "data-sb-field-path": "navItemIcon"
        } : null
      }), link?.text, displayChevrons && /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: `ter-mega-nav__link-chevron`,
        role: "img",
        "aria-label": "dropdown chevron icon"
      }, /*#__PURE__*/_react.default.createElement("path", {
        fill: "currentColor",
        d: "M1.88.453 8 6.56 14.12.453 16 2.333l-8 8-8-8L1.88.453Z"
      }))), !disableLinkDescriptions && /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-mega-nav__link-description"
      }, link?.description)));
    }), /*#__PURE__*/_react.default.createElement("li", {
      className: "ter-mega-nav__column-list-item"
    }, column?.subCategoryLink && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: column?.subCategoryLink?.url,
      Link: Link,
      target: column?.subCategoryLink?.external ? "_blank" : "_self",
      className: "ter-mega-nav__link ter-mega-nav__column-link"
    }, column?.subCategoryLink?.text))));
  };
  const renderMegaNavColumns = () => {
    if (content?.columns?.length >= 4) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `ter-mega-nav__column-limit`
      }, content?.columns?.map((column, index) => {
        return renderMegaNavColumn(column, index);
      }));
    } else {
      return content?.columns?.map((column, index) => {
        return renderMegaNavColumn(column, index);
      });
    }
  };
  const promoImageSizes = {
    desktop: {
      width: 250,
      height: 165,
      ratio: {
        width: 50,
        height: 33
      }
    },
    tablet: {
      width: 250,
      height: 165,
      ratio: {
        width: 50,
        height: 33
      }
    },
    mobile: {
      width: 250,
      height: 165,
      ratio: {
        width: 50,
        height: 33
      }
    }
  };
  const renderFeaturedPromoSection = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-mega-nav__column ter-mega-nav__featured-section`,
      ref: featuredColumnRef
    }, !content.navCategoryPromo?.pageLink && content?.featuredSection?.title && /*#__PURE__*/_react.default.createElement("span", {
      className: `ter-mega-nav__column-title`
    }, content?.featuredSection?.title), content.navCategoryPromo?.pageLink && /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-mega-nav__promo`
    }, content?.navCategoryPromo?.image && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-mega-nav__promo-image-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
      focalPointImage: content?.navCategoryPromo?.image?.focalPointImage,
      imageSizes: promoImageSizes,
      alt: content?.navCategoryPromo?.image?.focalPointImage?.title
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: `ter-mega-nav__promo-title`
    }, content.navCategoryPromo?.title), /*#__PURE__*/_react.default.createElement("span", {
      className: `ter-mega-nav__promo-description`
    }, content.navCategoryPromo?.description), content.navCategoryPromo?.pageLink?.url && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: content.navCategoryPromo?.pageLink?.url,
      target: content.navCategoryPromo?.pageLink?.external ? "_blank" : "_self",
      Link: Link,
      className: "ter-mega-nav__promo-link"
    }, content.navCategoryPromo?.pageLink?.text, /*#__PURE__*/_react.default.createElement("img", {
      src: _arrowDiagonalBlack.default,
      alt: "external link",
      className: "ter-mega-nav__promo-link-icon"
    }))), !content.navCategoryPromo?.pageLink &&
    /*#__PURE__*/
    // don't display a featuredSection if a promo is active
    _react.default.createElement("ul", {
      className: `ter-mega-nav__column-list`
    }, content?.featuredSection?.links?.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index,
        className: "ter-mega-nav__column-list-item"
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        key: index,
        to: link?.url,
        Link: Link,
        className: "ter-mega-nav__link",
        target: link?.external ? "_blank" : "_self"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-mega-nav__link-text"
      }, link?.icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: "ter-mega-nav__link-icon",
        size: "22px",
        type: link?.icon,
        sbProps: link?.contentfulId ? {
          "data-sb-field-path": "navItemIcon"
        } : null
      }), link?.text), /*#__PURE__*/_react.default.createElement("span", {
        className: "ter-mega-nav__link-description"
      }, link?.description)));
    }), content?.featuredSection?.subCategoryLink && /*#__PURE__*/_react.default.createElement("li", {
      className: "ter-mega-nav__column-list-item"
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: content?.featuredSection?.subCategoryLink?.url,
      Link: Link,
      className: "ter-mega-nav__link ter-mega-nav__column-link",
      target: content?.featuredSection?.subCategoryLink?.external ? "_blank" : "_self"
    }, content?.featuredSection?.subCategoryLink?.text))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mega-nav__section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-mega-nav__column-wrapper`
  }, renderMegaNavColumns(), renderFeaturedPromoSection()), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-mega-nav__column-end-indicator`
  })), showScrollIcon === true && /*#__PURE__*/_react.default.createElement(OverflowIndicator, {
    leftPos: featuredColumnRef
  }));
};
var _default = MegaNavSection;
exports.default = _default;